<template>
	<div id="nav" ref="navArea">
		<div class="all-nav">
			<span
				:class="['nav-item', {'active': currChannel === nav.id}]"
				@click="toNav(nav.id,nav.url, $event)"
				v-for="nav in navs"
				:key="nav.id"
			>{{ nav.channelName }}</span>
		</div>
	</div>
</template>

<script>
	import { scrollAni } from "../common.js";

	export default {
		name: "navBar",
		props: {
			navs: {
				required: true,
				type: Array,
			},
		},
		data() {
			return {};
		},
		methods: {
			toNav(cid, url, event) {
				if (url) {
					window.open(url);
					return;
				}
				let currChannel = +this.$route.params.channel;
				if (currChannel === cid) {
					return;
				}
				this.$parent.scrollTop[this.$route.params.channel] =
					document.documentElement.scrollTop;
				this.$router.push(`/index/${cid}`);
				let clientWidth = this.$refs.navArea.clientWidth;
				let x =
					event.x -
					(document.querySelector("#app")
						? document.querySelector("#app").offsetLeft
						: 0);
				if (x + 100 > clientWidth || x < 100) {
					let target = Math.max(
						0,
						this.$refs.navArea.scrollLeft +
							(x - Math.round(clientWidth / 2))
					);
					scrollAni(this.$refs.navArea, "scrollLeft", target, 200);
				}
			},
		},
		computed: {
			currChannel() {
				return +this.$route.params.channel;
			},
		},
	};
</script>
<style lang="scss">
	#nav {
		width: 100%;
		overflow-x: auto;
		background: #f4f5f7;
		// scroll-behavior: smooth;
		.all-nav {
			width: auto;
			display: inline-block;
			height: 35px;
			white-space: nowrap;
			padding: 0 10px;
		}
		.nav-item {
			display: inline-block;
			font-size: 18px;
			color: #444;
			line-height: 35px;
			cursor: pointer;
			margin-right: 20px;
			&.active {
				font-size: 19px;
				color: #fc1825;
			}
		}
	}
</style>